<script>
import GlyphCustomizationSlidingWindow
  from "@/components/modals/options/glyph-appearance/GlyphCustomizationSlidingWindow";

export default {
  name: "GlyphCustomizationSingleType",
  components: {
    GlyphCustomizationSlidingWindow,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    glyphId: {
      type: Number,
      required: false,
      default: -1,
    }
  },
  computed: {
    name() {
      let glyphName = "";
      switch (this.type) {
        case "power":
          glyphName = "Мощности";
          break;
        case "infinity":
          glyphName = "Бесконечности";
          break;
        case "replication":
          glyphName = "Репликации";
          break;
        case "time":
          glyphName = "Времени";
          break;
        case "dilation":
          glyphName = "Растяжения";
          break;
        case "effarig":
          glyphName = "Эффарига";
          break;
        case "companion":
          return "Глиф Компаньон";
        case "cursed":
          return "Проклятый Глиф";
        case "reality":
          return `Чистый Глиф Реальности`;
        default:
          return "Тип";
      }

      return glyphName;
    },
    symbols() {
      return GlyphAppearanceHandler.availableSymbols;
    },
    colors() {
      return GlyphAppearanceHandler.availableColors;
    },
  },
};
</script>

<template>
  <div class="c-glyph-customization-entry">
    <span
      v-if="glyphId === -1"
      class="c-name"
    >
      Опции вида для Глифов {{ name }}
    </span>
    <div v-if="type === 'companion'">
      У Глифов-Компаньонов нельзя изменить символ.
    </div>
    <GlyphCustomizationSlidingWindow
      v-else
      :type="type"
      :is-symbol="true"
      :options="symbols"
      :glyph-id="glyphId"
    />
    <GlyphCustomizationSlidingWindow
      :type="type"
      :is-symbol="false"
      :options="colors"
      :glyph-id="glyphId"
    />
  </div>
</template>

<style scoped>
.c-glyph-customization-entry {
  display: flex;
  flex-direction: column;
}

.c-name {
  width: 100%;
  margin: 0.5rem 0 0;
}
</style>
